import { render } from "./CardDetailPage.vue?vue&type=template&id=089d1ad3&scoped=true"
import script from "./CardDetailPage.vue?vue&type=script&lang=js"
export * from "./CardDetailPage.vue?vue&type=script&lang=js"

import "./CardDetailPage.vue?vue&type=style&index=0&id=089d1ad3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-089d1ad3"]])

export default __exports__